import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import CnfirmDeletePublished from "../../Published/Published_Q_list/Cnfirm_Delete_Published";
import DraftActivityPopup from "./DraftActivityPopup";
import axios from "../../../../../axios";
import NoResponse from "../../../../Pre-read/Create_Assessment_PreRead/create_successfullPreRead/NoResponse";
import { Tooltip } from "@mui/material";
import { MoreVertical } from "lucide-react";

// Subject icon mapper
const getSubjectIcon = (subjectName = "") => {
  const name = subjectName.toLowerCase().trim();

  if (["maths", "mathematics", "math"].some((s) => name.includes(s))) {
    return "/ActivityIcons/Maths_Lab_Icon-removebg-preview.png";
  }
  if (["english"].some((s) => name.includes(s))) {
    return "/ActivityIcons/English_Lab_Icon.png";
  }
  if (["hindi"].some((s) => name.includes(s))) {
    return "/ActivityIcons/Hindi_Lab_Icon-removebg-preview.png";
  }
  if (
    ["science", "physics", "chemistry", "biology", "botany", "zoology"].some(
      (s) => name.includes(s),
    )
  ) {
    return "/ActivityIcons/Science_Lab_Icon-removebg-preview.png";
  }

  return "/ActivityIcons/Any_others_Subjects_Lab_Icon-removebg-preview.png";
};

// Convert hex to RGB
const hexToRgb = (hex) => {
  const cleanHex = hex.replace("#", "");
  const bigint = parseInt(cleanHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};

// Create aesthetic gradient from subject color
const getSubjectGradient = (subjectColor = "4169E1") => {
  const hex = subjectColor.startsWith("#") ? subjectColor : `#${subjectColor}`;
  const { r, g, b } = hexToRgb(hex);

  const lightR = Math.min(255, r + 210);
  const lightG = Math.min(255, g + 210);
  const lightB = Math.min(255, b + 210);

  const medR = Math.min(255, r + 160);
  const medG = Math.min(255, g + 160);
  const medB = Math.min(255, b + 160);

  const ultraR = Math.min(255, r + 235);
  const ultraG = Math.min(255, g + 235);
  const ultraB = Math.min(255, b + 235);

  return `linear-gradient(145deg, 
    rgba(${lightR}, ${lightG}, ${lightB}, 0.9) 0%, 
    rgba(${medR}, ${medG}, ${medB}, 0.6) 50%,
    rgba(${ultraR}, ${ultraG}, ${ultraB}, 0.3) 100%)`;
};

// Badge style from subject color
const getSubjectBadgeStyle = (subjectColor = "4169E1") => {
  const hex = subjectColor.startsWith("#") ? subjectColor : `#${subjectColor}`;
  const { r, g, b } = hexToRgb(hex);

  return {
    backgroundColor: `rgba(${r}, ${g}, ${b}, 0.12)`,
    color: hex,
    border: `1px solid rgba(${r}, ${g}, ${b}, 0.25)`,
  };
};

const DraftAssessBoxActivity = ({ filter }) => {
  const [deletePublished, setDeletePublished] = useState();
  const [draftCard, setDraftCard] = useState([]);
  const [noresponse, setNoresponse] = useState(false);
  const [actId, setActId] = useState(null);
  const [isGettingData, setIsGettingData] = useState(true);
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  useEffect(() => {
    const draftBox = async () => {
      try {
        let response = await axios.get(
          `/api/v1/homework/activity/filterByTeacherId/${Teacher_Json}/draft?academic_session_id=${academicSessionId}&timetable_session_id=${timeTableSessionId}` +
            `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
            `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
            `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
            `&${filter?.date && `date=${filter?.date}`}` +
            `&${filter?.time && `time=${filter?.time}`}` +
            `&${
              filter?.subjectId?.length !== 0 &&
              `subjectId=${filter?.subjectId}`
            }`,
        );
        if (response?.data.data.length === 0) {
          setNoresponse(true);
        }
        setDraftCard(response.data.data);
      } catch (e) {
        console.log(e);
      } finally {
        setIsGettingData(false);
      }
    };
    draftBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, deletePublished]);

  function shortenParagraph(text, maxLength) {
    if (!text || text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength).trim() + "...";
  }

  return draftCard && draftCard.length > 0 ? (
    <>
      <div className="container">
        <div className="row">
          {draftCard
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            .map((draftData, idx) => {
              const subjectName = draftData?.subject_id?.name || "";
              const subjectColor =
                draftData?.subject_id?.subject_color || "4169E1";
              const activityName = draftData?.name || "";
              const subjectIcon = getSubjectIcon(subjectName);
              const cardGradient = getSubjectGradient(subjectColor);
              const badgeStyle = getSubjectBadgeStyle(subjectColor);

              return (
                <div key={idx} className="col-md-3 d-flex mb-3">
                  <div
                    className="w-100 h-100 d-flex flex-column shadow-sm rounded-4 overflow-hidden position-relative"
                    style={{
                      background: cardGradient,
                      border: "1px solid rgba(255,255,255,0.7)",
                      borderRadius: "1rem",
                      minHeight: "150px",
                      transition: "transform 0.25s ease, box-shadow 0.25s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 16px 32px rgba(0,0,0,0.08)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "";
                    }}
                  >
                    {/* Top bar: 3 dots only */}
                    <div className="d-flex justify-content-end px-3 pt-3">
                      <Popup
                        trigger={
                          <MoreVertical
                            size={18}
                            style={{
                              cursor: "pointer",
                              color: badgeStyle.color,
                            }}
                          />
                        }
                        content={
                          <div className="open_publish_activity_popupBox">
                            <DraftActivityPopup
                              draftData={draftData}
                              setDeletePublished={setDeletePublished}
                              activityId={draftData?.id}
                              setActId={setActId}
                            />
                          </div>
                        }
                        on="click"
                        hideOnScroll
                        position="bottom right"
                      />
                    </div>

                    {/* Main content area */}
                    <NavLink
                      to="/DraftQlistActivity"
                      className="text-decoration-none flex-grow-1"
                      state={{ draftActivitys_id: draftData?.id }}
                    >
                      <div
                        className="d-flex flex-row justify-content-between px-3"
                        style={{ marginTop: "-4px" }}
                      >
                        {/* Left column: Title + Badge + Updated on */}
                        <div
                          className="d-flex flex-column"
                          style={{ flex: 1, minWidth: 0 }}
                        >
                          {/* Title */}
                          <Tooltip
                            title={activityName}
                            arrow
                            placement="bottom"
                            enterDelay={200}
                            leaveDelay={100}
                          >
                            <h6
                              className="poppins-semibold mb-2"
                              style={{
                                fontSize: "1rem",
                                color: "#2d2d2d",
                                lineHeight: 1.3,
                              }}
                            >
                              {shortenParagraph(activityName, 28)}
                            </h6>
                          </Tooltip>

                          {/* Subject badge */}
                          <span
                            className="badge rounded-pill px-2 py-1 align-self-start"
                            style={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              ...badgeStyle,
                            }}
                          >
                            {`${draftData?.standard_id?.name || ""} - ${
                              draftData?.section_id?.name || ""
                            } | ${shortenParagraph(subjectName, 20)}`}
                          </span>

                          {/* Spacer to push icon area up */}
                          <div style={{ flex: 1, minHeight: "8px" }} />

                          {/* Updated on at bottom */}
                          <div
                            className="d-flex align-items-start"
                            style={{ fontSize: "0.8rem", color: "#666" }}
                          >
                            <span
                              className="me-1"
                              style={{ fontSize: "0.85rem" }}
                            >
                              📝
                            </span>
                            <div>
                              <span>Updated on: </span>
                              <span className="fw-medium text-dark">
                                {moment(draftData?.updated_at).calendar(null, {
                                  sameDay: "[Today]",
                                  nextDay: "[Tomorrow]",
                                  nextWeek: "DD/MM/YYYY",
                                  lastDay: "DD/MM/YYYY",
                                  lastWeek: "DD/MM/YYYY",
                                  sameElse: "DD/MM/YYYY",
                                })}
                                <span className="mx-1">|</span>
                                {moment(draftData?.updated_at).format("h:mm A")}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Right column: Icon - positioned between badge and updated on */}
                        <div
                          className="d-flex align-items-center ms-2"
                          style={{
                            width: "70px",
                            height: "70px",
                            flexShrink: 0,
                            marginTop: "4px",
                          }}
                        >
                          <img
                            src={subjectIcon}
                            alt={subjectName}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              objectPosition: "center",
                            }}
                          />
                        </div>
                      </div>
                    </NavLink>

                    {/* Bottom padding */}
                    <div className="pb-3" />
                  </div>

                  {deletePublished && (
                    <CnfirmDeletePublished
                      setDelete={setDeletePublished}
                      activitys={draftData}
                      activity_id={actId}
                    />
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </>
  ) : isGettingData ? (
    <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
  ) : (
    <div className="d-flex justify-content-center align-items-center w-100 h-100">
      <span
        className="badge bg-light text-dark px-4 py-3"
        style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
      >
        📭 Activity Not Found
      </span>
    </div>
  );
};

export default DraftAssessBoxActivity;
